import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const EmailVerification: React.FC = () => {
  const { labels } = useLanguage();
  
  return (
    <div className="bg-warning-50 text-warning-700 p-3 rounded-md text-sm text-center">
      {labels.verifyEmailMessage}
    </div>
  );
};

export default EmailVerification; 